import { useState } from 'react';
import './App.css';

import HomePage   from './components/HomePage';
import QuizPage   from './components/QuizPage';
import ResultsPage from './components/ResultsPage';
import { saveAttempt } from './utils/localStorage';

import { generateTopic1Questions } from './questions/topic1_compare';
import { generateTopic2Questions } from './questions/topic2_addsub';
import { generateTopic3Questions } from './questions/topic3_fraction_of';
import { generateTopic4Questions } from './questions/topic4_word_to_fraction';
import { generateTopic5Questions } from './questions/topic5_number_line';
import { generateTopic6Questions } from './questions/topic6_find_x';

function generateQuestions(topicId) {
  switch (topicId) {
    case 1: return generateTopic1Questions(5);
    case 2: return generateTopic2Questions(5);
    case 3: return generateTopic3Questions(5);
    case 4: return generateTopic4Questions(5);
    case 5: return generateTopic5Questions(5);
    case 6: return generateTopic6Questions(5);
    default: return [];
  }
}

export default function App() {
  const [view, setView]             = useState('home');
  const [quizContext, setQuizContext] = useState(null);

  function startQuiz(topicId) {
    const questions = generateQuestions(topicId);
    setQuizContext({ topicId, questions });
    setView('quiz');
  }

  function finishQuiz(topicId, score, total, answers) {
    const result = { topicId, score, total, answers };
    saveAttempt(topicId, result);
    setQuizContext(result);
    setView('results');
  }

  function goHome() {
    setQuizContext(null);
    setView('home');
  }

  if (view === 'home')
    return <HomePage onStart={startQuiz} />;

  if (view === 'quiz')
    return <QuizPage context={quizContext} onFinish={finishQuiz} />;

  if (view === 'results')
    return (
      <ResultsPage
        context={quizContext}
        onHome={goHome}
        onRetry={() => startQuiz(quizContext.topicId)}
      />
    );

  return null;
}
